import { Switch } from "@/components/ui/switch";
import { MAX_RANKING_INPUT } from "@/constants/dataset";
import { Dataset } from "@/types/dataset";

import { RankSlider } from "../RankSlider";

export interface RankSettingsProps {
  disabled?: boolean;
  isEnabled?: boolean;
  isRankable?: boolean;
  onCheckRank?: (value: boolean) => void;
  onChangeSlider?: (value: number[]) => void;
  onChangeInput?: (value: number) => void;
  data: Dataset;
  totalRows: number;
}
export const RankSettings = (props: RankSettingsProps) => {
  const {
    disabled,
    isEnabled,
    isRankable,
    onCheckRank,
    onChangeSlider,
    onChangeInput,
    data,
    totalRows
  } = props;
  return (
    <>
      <div className="flex justify-between">
        <p className="text-xs mb-1 text-grey">Enable Rank</p>
        <Switch
          disabled={disabled || !isRankable}
          data-testid="display-rank-switch"
          checked={isEnabled}
          onCheckedChange={onCheckRank}
        />
      </div>
      <RankSlider
        onChangeSlider={onChangeSlider}
        onChangeInput={onChangeInput}
        data={data}
        max={Math.min(totalRows, MAX_RANKING_INPUT)}
      />
    </>
  );
};
